import React from "react";
import { Link } from "react-router-dom";
import { LogoLockup } from "@/components/Logo";

export default function PaymentCancel() {
  return (
    <div className="min-h-screen bg-[var(--tm-off)] flex items-center justify-center p-5">
      <div className="w-full max-w-md">
        <div className="flex justify-center mb-8"><Link to="/"><LogoLockup /></Link></div>
        <div className="tm-card p-8 bg-white text-center" data-testid="payment-cancel">
          <h1 className="text-2xl font-bold">Checkout cancelled</h1>
          <p className="mt-2 text-sm text-[#3B424B]">No charge was made. You can come back any time.</p>
          <Link to="/#pricing" className="tm-btn-primary w-full mt-6">Back to pricing</Link>
        </div>
      </div>
    </div>
  );
}
